
export const inputTextLimit = 250;

